import React, { useEffect } from "react";

import { styled } from "@mui/material/styles";
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';

import { useAuth } from "../../services/AuthContext";
import { BaseControlProps } from "../../models/BaseControlProps";
import { mainListItems, secondaryListItems } from "./ListItem";
import { useLocation } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";

interface SidebarProps extends BaseControlProps {
    drawerWidth: number;
    open: boolean;
    toggleDrawer: () => void;
}

export function Sidebar(props: SidebarProps) {
    const loginContext = useAuth();
    const isAdmin = loginContext ? loginContext.isAdmin : 'false';
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 'sm' for small screens

    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
        ({ theme, open }) => ({
            '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: props.drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9),
                },
            }),
            },
        }),
    );

    useEffect(() => {
        if (isMobile && props.open) {
            props.toggleDrawer();
        }
    }, [isMobile]);

    return (
        <Drawer variant="permanent" open={props.open}>
        <Toolbar
            sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: [1],
            }}
        >
            {props.open ? (
                <IconButton 
                    onClick={props.toggleDrawer}
                    aria-label="Close navigation drawer"
                >
                    <ChevronLeftIcon />
                </IconButton>
            ): (
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={props.toggleDrawer}
                    sx={{
                        padding: {
                            xs: theme.spacing(1, 1),
                            sm: theme.spacing(2, 2),
                        }
                    }}
                    >
                    <MenuIcon />
                </IconButton>
            )}

        </Toolbar>
        <Divider />
        <List component="nav">
            { isAdmin === 'false' ? mainListItems(location.pathname) : null }
            {/* <Divider sx={{ my: 1 }} /> */}
            { isAdmin === 'true'  ? secondaryListItems(location.pathname, loginContext.isSuperAdmin === 'true') : null }
        </List>
        </Drawer>
    )
}